import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Token",
    component: () =>
      import(/* webpackChunkName: "Token" */ "../views/Token.vue"),
  },
  {
    path: "/agent",
    name: "Agent",
    component: () =>
      import(/* webpackChunkName: "Token" */ "../views/Agent.vue"),
  },
  {
    path: "/reports/:id",
    name: "reports",
    component: () =>
      import(/* webpackChunkName: "Reportes" */ "../views/Reportes.vue"),
  },
  {
    path: "/manager/:id",
    name: "manager",
    component: () =>
      import(/* webpackChunkName: "Manager" */ "../views/Manager.vue"),
  },
  {
    path: "/campanas/:id",
    name: "campanas",
    component: () =>
      import(/* webpackChunkName: "Campanas" */ "../views/Campanas.vue"),
  },
  {
    path: "/configuracion/:id",
    name: "configuracion",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "Configuracion" */ "../views/Configuracion.vue"
      ),
  },
  {
    path: "/encuestas/:id",
    name: "encuestas",
    component: () =>
      import(/* webpackChunkName: "Encuesta" */ "../views/Encuesta.vue"),
  },
  {
    path: "/whatsapp/:id",
    name: "whatsapp",
    component: () =>
      import(/* webpackChunkName: "WhatsApp" */ "../views/WhatsApp.vue"),
  },
  {
    path: "/facturacion/:id",
    name: "facturacion",
    component: () =>
      import(/* webpackChunkName: "WhatsApp" */ "../views/Facturacion.vue"),
  },
  {
    path: "/crm/:id",
    name: "crm",
    component: () =>
      import(/* webpackChunkName: "WhatsApp" */ "../views/crm.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
